import { DirectiveOptions } from 'vue';

export const visible: DirectiveOptions = {
	bind(el, binding) {
		el.style.visibility = binding.value ? 'visible' : 'hidden';
	},
	update(el, binding) {
		el.style.visibility = binding.value ? 'visible' : 'hidden';
	}
};
